module.exports = __webpack_public_path__ + "static/media/baseball.6daebbbf.png";